<main class="d-flex flex-column min-vh-100">
  <div class="flex-grow-1">
    <c2h-header></c2h-header>
    <zc-notification></zc-notification>
    <router-outlet></router-outlet>
  </div>
  <c2h-footer></c2h-footer>
</main>
